import { request } from "@/utils/request";

/**
 * 查询
 * @param {*} data
 * @returns
 */
export function selectOrder(data) {
  return request({
    url: `/admin/order/selectOrder`,
    method: "POST",
    data,
  });
}

/**
 * 更改
 * @param {*} data
 * @returns
 */
export function updateOrder(data) {
  return request({
    // headers: {
    //   "Content-Type": "application/x-www-form-urlencoded",
    // },
    url: `/admin/order/update`,
    method: "POST",
    data,
  });
}

/**
 * 删除
 * @param {*} data
 * @returns
 */
export function deleteOrder(data) {
  return request({
    url: `/admin/order/delete`,
    method: "POST",
    data,
  });
}

/**
 * 取货号播报
 * @param {*} data
 * @returns
 */
export function sendNumber(data) {
  return request({
    url: `/admin/order/sendNumber`,
    method: "POST",
    data,
  });
}


/**
 * 操作退款
 * @param {*} data
 * @returns
 */
export function refund(data) {
  return request({
    url: `/refund/create`,
    method: "POST",
    data,
  });
}
